import React, { useState } from 'react'
import Cookies from 'universal-cookie'
import PosMenuMovil from './PosMenuMovil';
import PosMenuEscritorio from './PosMenuEscritorio';
import axios from 'axios';
import PeticionTraeDatos from '../../componentesAdmin/hooks/useTraeDatos';


const baseUrl = process.env.REACT_APP_BASE_URL
const api = process.env.REACT_APP_API
const urlConfiguraciones = baseUrl + api + 'configuraciones/'

const PosMenu = (props) => {
    const [configuraciones] = PeticionTraeDatos(urlConfiguraciones)
    const dataConfiguracion = configuraciones ? configuraciones[16] : [];
    const alerta = dataConfiguracion ? JSON.parse(dataConfiguracion.valor) : []

    const { estadoInventario } = props;
    const Estado = () => {
        let colorNotificacion = ''
        let textoNotificacion = ''
        const sumarInventario = parseInt(estadoInventario?.inventarioMinimo || 0)
        const totalProductos = parseInt(estadoInventario?.totalProductos || 0)

        if (totalProductos > 0) {
            let Agota = alerta[0]
            let PocasExis = alerta[1]
            let EnExis = alerta[2]

            if (sumarInventario < parseInt(Agota?.rangofin)) {
                textoNotificacion = 'Agotado'
                colorNotificacion = 'Rojo'
            } else if (sumarInventario >= parseInt(PocasExis?.rangoini) && sumarInventario <= parseInt(PocasExis?.rangofin)) {
                textoNotificacion = 'Pocas Existencias'
                colorNotificacion = 'Amarillo'
            } else if (sumarInventario >= parseInt(EnExis?.rangoini)) {
                textoNotificacion = 'En Existencia'
                colorNotificacion = 'Verde'
            }
        }

        return {
            colorNotificacion,
            textoNotificacion
        }

    }


    const { colorNotificacion, textoNotificacion } = Estado()

    const cookies = new Cookies()

    const propsChildren = { ...props, cookies, colorNotificacion, textoNotificacion, Estado }
    return (
        <>
            <PosMenuMovil {...propsChildren} className="d-flex d-sm-flex d-md-none" />
            <PosMenuEscritorio  {...propsChildren} className="d-none d-sm-none d-md-flex" />
        </>

    )
}


export default PosMenu
